export { default } from "./GalleryTotalItems.vue";
